var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGatewayOr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 2048,
    width: 2048,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1024.0215 99.355469c-19.3234-.016932-38.64591 7.149111-52.98048 21.550781l-850.10352 850.11133c-28.66915 28.66788-28.536351 77.29502.13281 105.96292l849.97071 849.9648c28.66915 28.6776 77.29378 28.8033 105.96288 0l850.1055-850.0996c28.6691-28.6679 28.5364-77.29696-.1348-105.96484l-849.9726-849.97461c-14.3346-14.33394-33.6571-21.533849-52.9805-21.550781zm-.0645 126.044921 798.6602 798.66601-798.6602 798.6563-798.66012-798.6563zm.043 368.59961c-237.23182 0-430 192.77939-430 430.0078 0 237.2284 192.76818 430 430 430 237.2318 0 430-192.7716 430-430 0-237.22841-192.7682-430.0078-430-430.0078zm0 47.68945c211.4073 0 382.3223 170.91329 382.3223 382.31835 0 211.4051-170.915 382.3301-382.3223 382.3301-211.40721 0-382.32227-170.925-382.32227-382.3301 0-211.40506 170.91506-382.31835 382.32227-382.31835z",
    transform: "matrix(1.00000018909 0 0 1.00000018909 .00001499425 .00459879149)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatewayOr);
export default __webpack_public_path__ + "static/media/gateway-or.ac310abf594fab335b53a18eec528194.svg";
export { ForwardRef as ReactComponent };